const giftCardSelectors = {
  instanFeed: document.getElementById('index-instagram-feed'),
};
class templalteIndexJS {
  constructor() {
    if (giftCardSelectors.instanFeed) this.manageInstaJS();
  }

  manageInstaJS() {
    const onIntersection = entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          let instaScript = document.createElement('script');
          instaScript.src =
            'https://cdn.nfcube.com/d625e6c256304ac7278dae5d1df06df6.js';
          instaScript.dataset.shopname = 'grill-masters-club.myshopify.com';
          document.body.appendChild(instaScript);
          observer.disconnect();
        }
      }
    };
    const observer = new IntersectionObserver(onIntersection);
    observer.observe(giftCardSelectors.instanFeed);
  }
}
typeof templalteIndexJS !== 'undefined' && new templalteIndexJS();
